module.exports = __webpack_public_path__ + "static/img/Sayed.6c0f006.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/photos/testimonials/vantage/Sayed.png
// module id = r4Ca
// module chunks = 0